module.exports = __webpack_public_path__ + "static/media/icons.9c25bb90.svg";